module.exports = __webpack_public_path__ + "img/fa-v2-light-300.6bbd339e.svg";